import * as THREE from 'three';
import 'remixicon/fonts/remixicon.css'
import { StorylineShader } from './StorylineShader.js';
import { initializeRaycastControls } from './MouseControls.js';
import { createTextTexture } from './TextureUtils.js';
import gsap from 'gsap';
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);


// -------------------- LOAD MANAGER -------------------
const loadingManager = new THREE.LoadingManager();

// Track the start, progress, and completion of loading
loadingManager.onStart = function (url, itemsLoaded, itemsTotal) {
    // console.log(`Started loading: ${url}`);
};

loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
    // console.log(`Loading: ${url}, ${itemsLoaded} of ${itemsTotal} items loaded`);
};

loadingManager.onLoad = function () {
};




// ------------------------------ WEBGL --------------------------
const textureLoader = new THREE.TextureLoader(loadingManager);

// Canvas
const canvas = document.querySelector('canvas.webgl');
const scene = new THREE.Scene();

// scene.background = new THREE.Color(0xeeeeee); 

const ControlProperties = {
    isCameraAnimating: false, // do not modify this
    imageAspectRatio: 1.,
    videoAspectRatio: 1.77,
    // videoAspectRatio: sizes.width / sizes.height,
    // ZoomDist: 1.5
    ZoomDist: window.innerWidth > 786? 2.3 :9.,
};

//images



const groupPos = {
    abchance: {x: 0, y: 0},
    ackerman_r: {x: 0, y: 0},
    ackerman_s: {x: 0, y: 0},
    clemson: {x: 0, y: 0},
    costner: {x: 0, y: 0},
    enmarket: {x: 0, y: 0},
    fiddlers_f: {x: 0, y: 0},
    king_of_the_chill: {x: 0, y: 0},
    lectro: {x: 0, y: 0},
    maw: {x: 0, y: 0},
    nike_hadar: {x: 13, y: 0},
    notre: {x:25, y:5},
}

const data = [
    {
        groupName: "homePlane",
        images: [
            {
                src: textureLoader.load(new URL("./assets/logo.png", import.meta.url).toString()),
                width: 875,
                height: 700,
                position: {x:0, y: -1}
            }
        ],
        videoSrc: new URL('./assets/Final_720_Brandtec_reel_12.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "abchance",
        images: [
            {
                src: textureLoader.load(new URL("./assets/abchance/150x150_AB_Chance_spot.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:19, y: 3}
            }, {
                src: textureLoader.load(new URL("./assets/abchance/167x275_AB_Chance_spot.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:25.6, y: 6.2}
            }, {
                src: textureLoader.load(new URL("./assets/abchance/170x340_AB_Chance_spot.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:25.4, y: 2.5}
            }, {
                src:textureLoader.load(new URL("./assets/abchance/325x150_AB_Chance_spot.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:22.5, y: 6.2}
            }, {
                src:textureLoader.load(new URL("./assets/abchance/350x350_AB_Chance_spot.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:22.2, y: 3}
            }],
        videoSrc: new URL('./assets/abchance/abchance_vid.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "ackerman_r",
        images: [
        {
            src: textureLoader.load(new URL("./assets/ackerman_r/150x150_Ackerman_R_F.png", import.meta.url).toString()),
            width: 150,
            height: 150,
            position: {x:12, y: 11}
        }, {
            src: textureLoader.load(new URL("./assets/ackerman_r/167x275_Ackerman_R_F.png", import.meta.url).toString()),
            width: 167,
            height: 275,
            position: {x:19.2, y: 14.5}
        }, {
            src: textureLoader.load(new URL("./assets/ackerman_r/thumbnail_170x340_Ack_Creed_F.png", import.meta.url).toString()),
            width: 170,
            height: 340,
            position: {x:18.5, y: 10.6}
        }, {
            src:textureLoader.load(new URL("./assets/ackerman_r/325x150_Ackerman_R_F.png", import.meta.url).toString()),
            width: 325,
            height: 150,
            position: {x:16, y: 14.2}
        }, {
            src:textureLoader.load(new URL("./assets/ackerman_r/350x350_Ackerman_R_F.png", import.meta.url).toString()),
            width: 350,
            height: 350,
            position: {x:15.2, y: 11}
        }],
        videoSrc: new URL('./assets/ackerman_r/Recruitment_Video_full_Ackerman.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "ackerman_s",
        images: [
            {
                src: textureLoader.load(new URL("./assets/ackerman_s/150x150_Ack_Creed_F.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-15, y: -3}
            }, {
                src: textureLoader.load(new URL("./assets/ackerman_s/167x275_Ack_Creed_F.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:-7.9, y: 0.5}
            }, {
                src: textureLoader.load(new URL("./assets/ackerman_s/170x340_Ack_Creed_F.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-8.6, y: -3.4}
            }, {
                src:textureLoader.load(new URL("./assets/ackerman_s/325x150_Ack_Creed_F.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:-11.1, y: 0.2}
            }, {
                src:textureLoader.load(new URL("./assets/ackerman_s/350x350_Ack_Creed_F.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:-11.9, y: -3}
            }],
        videoSrc: new URL('./assets/ackerman_s/2nd_Ackerman_Spped_is_our_creed_fixedRevised_Spot 2.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "clemson",
        images: [
            {
                src: textureLoader.load(new URL("./assets/clemson/170x340_Clemson.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-15, y: -14}
            }, {
                src: textureLoader.load(new URL("./assets/clemson/thumbnail_150x150_Clemson.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:-7.9, y: -10.5}
            }, {
                src: textureLoader.load(new URL("./assets/clemson/thumbnail_167x275_Clemson.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-8.6, y: -14.4}
            }, {
                src:textureLoader.load(new URL("./assets/clemson/thumbnail_325x150_Clemson.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:-11.1, y: -10.8}
            }, {
                src:textureLoader.load(new URL("./assets/clemson/thumbnail_350x350_Clemson.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:-11.9, y: -14}
            }],
        videoSrc: new URL('./assets/clemson/Clemson_720.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "costner",
        images: [
            {
                src: textureLoader.load(new URL("./assets/costner/thumbnail_150x150_Costner.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-27, y: -10}
            }, {
                src: textureLoader.load(new URL("./assets/costner/thumbnail_167x275_Costner.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:-19.9, y: -6.5}
            }, {
                src: textureLoader.load(new URL("./assets/costner/170x340_Costner.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-20.6, y: -10.4}
            }, {
                src:textureLoader.load(new URL("./assets/costner/thumbnail_325x150_Costner.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:-23.1, y: -6.8}
            }, {
                src:textureLoader.load(new URL("./assets/costner/350x350_Costner.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:-23.9, y: -10}
            }],
        videoSrc: new URL('./assets/costner/costner_vid.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "enmarket",
        images: [
            {
                src: textureLoader.load(new URL("./assets/enmarket/thumbnail_150x150_Enmarket_Drive.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:8.6, y: 0}
            }, {
                src: textureLoader.load(new URL("./assets/enmarket/thumbnail_167x275_Enmarket_Drive.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:8.5, y: -2.8}
            }, {
                src: textureLoader.load(new URL("./assets/enmarket/thumbnail_170x340_Enmarket_Drive.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:12.7, y: 3.1}
            }, {
                src:textureLoader.load(new URL("./assets/enmarket/325x150_Enmarket_Drive.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:9.5, y: 2}
            }, {
                src:textureLoader.load(new URL("./assets/enmarket/350x350_Enmarket_Drive.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:11.8, y: -1.2}
            }],
        videoSrc: new URL('./assets/enmarket/Enmarket_2.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "fiddlers_f",
        images: [
            {
                src: textureLoader.load(new URL("./assets/fiddlers_f/150x150_Fiddlers_Ingreds_F.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-12.2, y: 9.15}
            }, {
                src: textureLoader.load(new URL("./assets/fiddlers_f/167x275_Fiddlers_Ingreds_F.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:-5.5, y: 7.8}
            }, {
                src: textureLoader.load(new URL("./assets/fiddlers_f/170x340_Fiddlers_Ingreds_F.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-12.15, y: 6}
            }, {
                src:textureLoader.load(new URL("./assets/fiddlers_f/325x150_Fiddlers_Ingreds_F.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:-8.9, y: 10}
            }, {
                src:textureLoader.load(new URL("./assets/fiddlers_f/350x350_Fiddlers_Ingreds_F.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:-8.8, y: 6.8}
            }],
        videoSrc: new URL('./assets/fiddlers_f/fiddlers_oceanfest.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "king_of_the_chill",
        images: [
            {
                src: textureLoader.load(new URL("./assets/king_of_the_chill/thumbnail_150x150_King_of_the_Chill.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-.2, y: 7.5}
            }, {
                src: textureLoader.load(new URL("./assets/king_of_the_chill/thumbnail_167x275_King_of_the_Chill.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:6.3, y: 9.3}
            }, {
                src: textureLoader.load(new URL("./assets/king_of_the_chill/thumbnail_170x340_King_of_the_Chill.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-0.35, y: 10.6}
            }, {
                src:textureLoader.load(new URL("./assets/king_of_the_chill/thumbnail_325x150_King_of_the_Chill.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:3.5, y: 12}
            }, {
                src:textureLoader.load(new URL("./assets/king_of_the_chill/350x350_King_of_the_Chill.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:3, y: 8.8}
            }],
        videoSrc: new URL('./assets/king_of_the_chill/King_of_The_Chill_Enmarket.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "lectro",
        images: [
            {
                src: textureLoader.load(new URL("./assets/lectro/150x150_Lectro_F.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-24.1, y: 4}
            }, {
                src: textureLoader.load(new URL("./assets/lectro/167x275_Lectro_F.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:-22, y: 4.7}
            }, {
                src: textureLoader.load(new URL("./assets/lectro/170x340_Lectro_F.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-26.5, y: 2.5}
            }, {
                src:textureLoader.load(new URL("./assets/lectro/325x150_Lectro_F.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x:-19, y: 1.5}
            }, {
                src:textureLoader.load(new URL("./assets/lectro/350x350_Lectro_F.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:-23.2, y: 0.8}
            }],
        videoSrc: new URL('./assets/lectro/lectro_vid.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "maw",
        images: [
            {
                src: textureLoader.load(new URL("./assets/maw/150x150__MAW_F.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-1.3, y: -9.2}
            }, {
                src: textureLoader.load(new URL("./assets/maw/167x275_MAW_F.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:5, y: -8.7}
            }, {
                src: textureLoader.load(new URL("./assets/maw/170x340__MAW_F.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:3.6, y: -12.8}
            }, {
                src:textureLoader.load(new URL("./assets/maw/325x150__MAW_F.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x: 1.8, y: -9.5}
            }, {
                src:textureLoader.load(new URL("./assets/maw/350x350__MAW_F.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:0.2, y: -12.8}
            }],
        videoSrc: new URL('./assets/maw/Make-A-Wish_video_720.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "nike_hadar",
        images: [
            {
                src: textureLoader.load(new URL("./assets/nike_hadar/thumbnail_150x150_NIKE_Hadar.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:0.8+groupPos.nike_hadar.x, y: -9.2+groupPos.nike_hadar.y}
            }, {
                src: textureLoader.load(new URL("./assets/nike_hadar/thumbnail_167x275_NIKE_Hadar.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:5+groupPos.nike_hadar.x, y: -11.9+groupPos.nike_hadar.y}
            }, {
                src: textureLoader.load(new URL("./assets/nike_hadar/170x340_NIKE_Hadar.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-1.5+groupPos.nike_hadar.x, y: -10.5+groupPos.nike_hadar.y}
            }, {
                src:textureLoader.load(new URL("./assets/nike_hadar/thumbnail_325x150_NIKE_Hadar.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x: 3.9+groupPos.nike_hadar.x, y: -9.2+groupPos.nike_hadar.y}
            }, {
                src:textureLoader.load(new URL("./assets/nike_hadar/thumbnail_350x350_NIKE_Hadar.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:1.8+groupPos.nike_hadar.x, y: -12.4+groupPos.nike_hadar.y}
            }],
        videoSrc: new URL('./assets/nike_hadar/nike austria.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
    {
        groupName: "notre",
        images: [
            {
                src: textureLoader.load(new URL("./assets/notre/150x150_Notre_Dame_F.png", import.meta.url).toString()),
                width: 150,
                height: 150,
                position: {x:-1.4+groupPos.notre.x, y: -9.2+groupPos.notre.y}
            }, {
                src: textureLoader.load(new URL("./assets/notre/167x275_Notre_Dame_F.png", import.meta.url).toString()),
                width: 167,
                height: 275,
                position: {x:5+groupPos.notre.x, y: -8.7+groupPos.notre.y}
            }, {
                src: textureLoader.load(new URL("./assets/notre/170x340_Notre_Dame_F.png", import.meta.url).toString()),
                width: 170,
                height: 340,
                position: {x:-1.5+groupPos.notre.x, y: -12.5+groupPos.notre.y}
            }, {
                src:textureLoader.load(new URL("./assets/notre/325x150_Notre_Dame_F.png", import.meta.url).toString()),
                width: 325,
                height: 150,
                position: {x: 1.8+groupPos.notre.x, y: -13.2+groupPos.notre.y}
            }, {
                src:textureLoader.load(new URL("./assets/notre/350x350_Notre_Dame_F.png", import.meta.url).toString()),
                width: 350,
                height: 350,
                position: {x:1.8+groupPos.notre.x, y: -10+groupPos.notre.y}
            }],
        videoSrc: new URL('./assets/notre/notre_dame_video.mp4', import.meta.url).toString(),
        // videoSrc: undefined,
    },
]

const HomeImage = textureLoader.load(new URL('./assets/logo.png', import.meta.url).toString());


const RoundedSqMask = textureLoader.load(new URL('./assets/RoundedSquare.png', import.meta.url).toString());
const planeGeometry = new THREE.PlaneGeometry(5, 5, 30, 30);
const planes = [];
let totalVideos = data.length;
let videosLoaded = 0;

data.forEach(element => {
    const videoElement = document.createElement('video');
    videoElement.autoplay = false;
    videoElement.playsInline = true; // Important for iOS
    videoElement.muted = true; // Required for autoplay in most browsers
    videoElement.loop = true;
    videoElement.crossOrigin = 'anonymous';
    videoElement.preload = 'metadata'; // Only load metadata initially for faster loading
    videoElement.setAttribute('playsinline', ''); // Ensure iOS compatibility
    videoElement.setAttribute('webkit-playsinline', ''); // For older iOS versions
    
    // Create video texture with optimized settings
    const videoTexture = new THREE.VideoTexture(videoElement);
    videoTexture.minFilter = THREE.LinearFilter;
    videoTexture.magFilter = THREE.LinearFilter;
    videoTexture.format = THREE.RGBAFormat;
    videoTexture.generateMipmaps = false; // Disable mipmaps for better performance

    // Set lower quality for initial loading
    if (videoElement.canPlayType('video/webm')) {
        videoElement.type = 'video/webm; codecs="vp9"'; // More efficient codec if supported
    } else {
        videoElement.type = 'video/mp4; codecs="avc1.42E01E"'; // Fallback to H.264
    }

    element.images.forEach((image, index) => {
        const imageTexture = image.src;
        const shaderUniforms = {
            _mainTex: { value: imageTexture },
            _maskTex: { value: RoundedSqMask },
            _objPos: { value: new THREE.Vector3() },
            _curvatureStrength: { value: 0.1 },
            _imageSlideSterngth: { value: 0.01 },
            _isScroll: { value: false},
            _aspectRatio: { value: ControlProperties.imageAspectRatio },
        };
    
        const planeMaterial = new THREE.ShaderMaterial({
            vertexShader: StorylineShader.vertexShader,
            fragmentShader: StorylineShader.fragmentShader,
            uniforms: shaderUniforms,
            transparent: true,
        });
        
        const plane = new THREE.Mesh(planeGeometry, planeMaterial);
        plane.originalTexture = imageTexture;
        plane.videoElement = videoElement;
        plane.videoTexture = videoTexture;
        plane.position.set(image.position.x, image.position.y, 0);
        const scale = new THREE.Vector3(image.width / 350, image.height / 350, 1);
        plane.scale.copy(scale);
        plane.originalScale = scale.clone();
        
        scene.add(plane);
        planes.push(plane);
    });
    
    // Add event listeners to handle loading and errors
    videoElement.addEventListener('loadeddata', () => {
        console.log('Video data loaded successfully');
        videosLoaded++;
        
        // Check if all videos are loaded
        if (videosLoaded === totalVideos) {
            console.log('All videos loaded, hiding loader');
            document.querySelector("#loader").style.display = "none";
        }
    });
    
    videoElement.addEventListener('error', (e) => {
        console.warn('Video loading error:', e);
        videosLoaded++;
        
        // Even if there's an error, we still count it as "loaded" to avoid blocking the UI
        if (videosLoaded === totalVideos) {
            console.log('All videos processed, hiding loader');
            document.querySelector("#loader").style.display = "none";
        }
    });
    
    // Set video source after adding event listeners
    if (element.videoSrc) {
        videoElement.src = element.videoSrc;
        videoElement.load(); // Start loading the video
    } else {
        // If no video source, count it as already loaded
        videosLoaded++;
        if (videosLoaded === totalVideos) {
            console.log('All videos loaded, hiding loader');
            document.querySelector("#loader").style.display = "none";
        }
    }
});


//#region Initialize Scene
const sizes = {
    width: canvas.clientWidth,
    height: canvas.clientHeight
};

const camera = new THREE.PerspectiveCamera(85, sizes.width / sizes.height, 0.5, 1000); 
camera.position.set(0, 0, 8.0);
scene.add(camera);



// SETING THE BACKGROUND IMAGE OF THE SCENE - START

function createFullScreenPlane() {
    const distance = camera.position.z; // Distance from camera
    const vFOV = (camera.fov * Math.PI) / 180; // Convert FOV to radians
    const height = 2 * Math.tan(vFOV / 2) * distance; // Visible height
    const width = height * camera.aspect; // Visible width based on aspect ratio
  
    const geometry = new THREE.PlaneGeometry(width, height);
    const material = new THREE.MeshBasicMaterial({ map: bgTexture }); // Change color or texture
    const plane = new THREE.Mesh(geometry, material);
    scene.add(plane);
    return plane;
}

// let bgPlane = createFullScreenPlane();

// SETING THE BACKGROUND IMAGE OF THE SCENE - END

const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    alpha: true,
    powerPreference: 'high-performance',
    raytracingEnabled: true,
    raytracingQuality: 'high',
    raytracingSamples: 64,
    raytracingMaxTraceDepth: 8,
    raytracingToneMapping: THREE.ACESFilmicToneMapping,
    side: THREE.DoubleSide,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.shadowMap.enabled = true;

//#endregion


//#region home and text planes
const bgTexture = textureLoader.load(new URL('./assets/bgImage.jpeg', import.meta.url).toString());
bgTexture.colorSpace = THREE.SRGBColorSpace;


const homePlaneMaterial = new THREE.ShaderMaterial({
    vertexShader: StorylineShader.vertexShader,
    fragmentShader: StorylineShader.fragmentShader,
    uniforms: {
        _mainTex: { value: HomeImage },
        _maskTex: { value: RoundedSqMask },
        _objPos: { value: new THREE.Vector3() },
        _curvatureStrength: { value: 0.1 },
        _imageSlideSterngth: { value: 0.0 },
        _isScroll: { value: false},
        _scrollSpeed: { value: 0.0 },
        _time: { value: 0.0},
        _aspectRatio: { value: 1.0 },
    },
    transparent: true
});

// const homePlane = new THREE.Mesh(planeGeometry, homePlaneMaterial);
// homePlane.position.set(0.0, -1.0, 0.0);
// homePlane.scale.set(2.5, 2.0, 0.0);
// scene.add(homePlane);


// const text = "The Technology of Branding .com...  ";
// const textOptions = {
//     width: 1024,
//     height: 256,
//     backgroundColor: 'white', // You can set this to any color or keep it transparent
//     textColor: '#000', // Red text
//     font: '48px Arial', // Larger font size
//     textAlign: 'center',
//     textBaseline: 'middle'
// };

// const textTexture = createTextTexture(text, textOptions);

// const textPlaneMaterial = homePlaneMaterial.clone();
// const textPlane = new THREE.Mesh(planeGeometry, textPlaneMaterial);
// textPlane.material.uniforms._mainTex.value = textTexture;
// textPlane.material.uniforms._mainTex.needsUpdate = true;
// textPlane.material.uniforms._isScroll.value = true;
// textPlane.material.uniforms._scrollSpeed.value = 0.2;
// textPlane.position.set(0.0, 4.2, 0.0);
// textPlane.scale.set(2.0, 0.2, 0.0);
// scene.add(textPlane)

//#endregion



// Target position for camera panning
const targetPosition = new THREE.Vector3(camera.position.x, camera.position.y, camera.position.z);

// Parameters for smoothing
const dampingFactor = 0.03; // Adjust for smoothing speed
let panMultiplier = window.matchMedia('(max-width: 768px)').matches ? 0.07 : 0.03; // Adjust to control how fast the camera pans per pixel movement

// Mouse dragging variables
let isDragging = false;
const lastMouse = new THREE.Vector2();
// let deltaMouseSpeed = 0;
// let deltaTouchSpeed = 0;

renderer.domElement.addEventListener('mousedown', (e) => {
    isDragging = true;
    lastMouse.set(e.clientX, e.clientY);
    // deltaMouseSpeed = 0;
    // deltaTouchSpeed = 0;
});

window.addEventListener('mouseup', () => {
    isDragging = false;
    // deltaMouseSpeed = 0;
    // deltaTouchSpeed = 0;
});

const backgroundImage = document.querySelector(".bg-image-container .bg-image");
const dragGuide = document.querySelector(".drag-guide")
const movementSpeed = 2; // BACKGROUND IMAGE MOVEMENT SPEED


window.addEventListener('mousemove', (e) => {
    gsap.to(dragGuide, {
        top: `${e.clientY}px`,
        left: `${e.clientX}px`,
        duration: 1.1,
        ease: CustomEase.create("custom", "0.22, 1, 0.36, 1"),

        onStart: ()=>{
            gsap.to(dragGuide, {
                opacity: 1,
                duration: 0.8,
            })
        }
    })

    if (isDragging) {
        const deltaX = e.clientX - lastMouse.x;
        const deltaY = e.clientY - lastMouse.y;
        
        // Adjust targetPosition based on mouse delta, invert directions as needed
        targetPosition.x -= deltaX * panMultiplier;
        targetPosition.y += deltaY * panMultiplier;

        
        lastMouse.set(e.clientX, e.clientY);

        // BACKGROUND MOVEMENT CODE FOR DESKTOP
        gsap.to(backgroundImage, {
            x: -targetPosition.x*movementSpeed,
            y: targetPosition.y*movementSpeed,
            duration: 0.5,
            ease: 'easeInOutQuad'
        })

        gsap.to(".drag-guide", {
            opacity: 0,
            duration: 0.3,
            onComplete: ()=>{
                dragGuide.style.display = "none";
            }
        })

        // Calculate mouse movement speed using clientX/Y differences instead of movementX/Y
        // This is more compatible across browsers including Edge
        // const currentMouseX = e.clientX;
        // const currentMouseY = e.clientY;
        
        // // Store previous mouse position in a variable if not already defined
        // if (!window.prevMouseX) window.prevMouseX = currentMouseX;
        // if (!window.prevMouseY) window.prevMouseY = currentMouseY;
        
        
        // // Update previous position for next frame
        // window.prevMouseX = currentMouseX;
        // window.prevMouseY = currentMouseY;
        
        // const mouseSpeed = Math.sqrt(
        //     Math.pow(deltaX, 2) + Math.pow(deltaY, 2)
        // ) * 0.15; // Reduce the speed impact

        // // Limit the mouse speed to a maximum value
        // const cappedMouseSpeed = Math.min(mouseSpeed, 15);
        
        // // FORWARD AND BACKWARD ZOOM EFFECTS FOR SCREENS WITHOUT TOUCH
        // if(cappedMouseSpeed > deltaMouseSpeed){
        //     deltaMouseSpeed = cappedMouseSpeed - deltaMouseSpeed;
        // }else{
        //     deltaMouseSpeed = deltaMouseSpeed - cappedMouseSpeed;
        // }
        
        // // Ensure deltaMouseSpeed stays within a reasonable range
        // deltaMouseSpeed = Math.min(deltaMouseSpeed, 15);
        
        // // Smoothly interpolate camera position
        // gsap.to(camera.position, {
        //     duration: 0.5,
        //     z: 8 + deltaMouseSpeed,
        //     ease: "none"
        // });

    }
});

// Touch dragging variables
let isTouching = false;
const lastTouch = new THREE.Vector2();

// Touch Start
renderer.domElement.addEventListener('touchstart', (e) => {
    // deltaTouchSpeed = 0;
    dragGuide.style.display = "none";
    if (e.touches.length === 1) { // Single touch only
        isTouching = true;
        lastTouch.set(e.touches[0].clientX, e.touches[0].clientY);
    }
}, { passive: false });

// Touch Move
renderer.domElement.addEventListener('touchmove', (e) => {
    if (isTouching && e.touches.length === 1) {
        const deltaX = e.touches[0].clientX - lastTouch.x;
        const deltaY = e.touches[0].clientY - lastTouch.y;

        // Adjust targetPosition based on touch delta
        targetPosition.x -= deltaX * panMultiplier;
        targetPosition.y += deltaY * panMultiplier;

        // BACKGROUND MOVEMENT CODE FOR MOBILES
        gsap.to(backgroundImage, {
            x: -targetPosition.x*movementSpeed,
            y: targetPosition.y*movementSpeed,
            duration: 0.5,
            ease: 'easeInOutQuad'
        })

        lastTouch.set(e.touches[0].clientX, e.touches[0].clientY);

        // Calculate touch movement speed
        // const touchSpeed = Math.sqrt(deltaX * deltaX + deltaY * deltaY)*0.06;
        
        // FORWARD AND BACKWARD ZOOM EFFECT
        // if(touchSpeed > deltaTouchSpeed){
        //     deltaTouchSpeed += touchSpeed - deltaTouchSpeed;
        // }else{
        //     deltaTouchSpeed -= deltaTouchSpeed - touchSpeed;
        // }
        
        // gsap.to(camera.position, {
        //     duration: 0.25,
        //     z:8-deltaTouchSpeed,
        //     ease: "none" // Smoother easing for mobile
        // });
    }
    // Prevent default to avoid scrolling when interacting with the canvas
    e.preventDefault();
}, { passive: false });

// Touch End
renderer.domElement.addEventListener('touchend', () => {
    isTouching = false;
    deltaMouseSpeed = 0;
});


initializeRaycastControls(scene, camera, canvas, planes, ControlProperties, targetPosition);


let startTime = Date.now();
function animate() {
    const elapsedMilliseconds = Date.now() - startTime;
    const elapsedSeconds = elapsedMilliseconds / 1000;
    
    if (!ControlProperties.isCameraAnimating){
        camera.position.lerp(targetPosition, dampingFactor);
    }
    
    
    for (let i = 0; i < planes.length; i++) {
        const plane = planes[i];       
        plane.material.uniforms._objPos.value.copy(plane.position);
    }
    // homePlane.material.uniforms._objPos.value.copy(homePlane.position);
    // textPlane.material.uniforms._objPos.value.copy(textPlane.position);
    // textPlane.material.uniforms._time.value = elapsedSeconds;

    
    renderer.render(scene, camera);
    requestAnimationFrame(animate);    
}

animate();

// Handle window resize
window.addEventListener('resize', () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    ControlProperties.ZoomDist = window.innerWidth > 786? 2.3 :9.,

    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    panMultiplier = window.matchMedia('(max-width: 768px)').matches ? 0.07 : 0.03; // Adjust to control how fast the camera pans per pixel movement
    
    // scene.remove(bgPlane);
    // bgPlane = createFullScreenPlane();
});